import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";

import { attachmentIdentifierStruct } from "./attachmentIdentifierStruct";

export const attachmentResourceStruct = createResourceStruct({
  identifier: attachmentIdentifierStruct,
  attributes: sup.object({
    contentType: sup.string(),
    fileName: sup.string(),
  }),
});

export const attachmentWithUrlResourceStruct = createResourceStruct({
  identifier: attachmentIdentifierStruct,
  attributes: sup.object({
    contentType: sup.string(),
    fileName: sup.string(),
    url: sup.string(),
  }),
});

export type AttachmentResource = sup.Infer<typeof attachmentResourceStruct>;
export type AttachmentWithUrlResource = sup.Infer<
  typeof attachmentWithUrlResourceStruct
>;
